import React, { useState } from 'react';
import Modal from '@carvana/showroom-modal';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ModalContent, DuoCheckmark, CloseButton } from './BankSuccess.styles';
import { getCurrentVehicleId } from '../../../../ducks/selectors';
import { fetchBankDetails } from '../../../../ducks/actions';
import { currentAssetsUrl } from '../../../../utils/baseUrlUtil';

const BankSuccess = (props: { isOpen: any }) => {
  const { isOpen } = props;
  const [openSuccessModal, setOpenModal] = useState(isOpen);
  const history = useHistory();
  const dispatch = useDispatch();
  const vehicleId = useSelector(getCurrentVehicleId);

  const closeModal = () => {
    setOpenModal(!openSuccessModal);
    dispatch(fetchBankDetails(process.env.NODE_ENV, vehicleId));
    history.push(`/loan-detail/${vehicleId}`);
  };

  return (
    <Modal
      headerText="SUCCESS"
      closeModal={closeModal}
      isOpen={openSuccessModal}
      testHook="test-modal"
      mode="light"
      portalDivId="divider"
    >
      <ModalContent>
        <DuoCheckmark
          src={`${currentAssetsUrl(
            process.env.NODE_ENV
          )}/op-assets/my-cars/DuoCheck.png`}
        />
        PAYMENT METHOD UPDATED!
        <CloseButton onClick={closeModal}>CLOSE WINDOW</CloseButton>
      </ModalContent>
    </Modal>
  );
};

export default BankSuccess;
